import './App.css';

import { useEffect, useState } from 'react';
import { Routes, Route } from 'react-router-dom';

// Helpers
import { getUser } from '../utilities/services/clients';

// Components
import Login from '../pages/Login/Login';
import NavBar from '../components/NavBar/NavBar';
import { getServices } from '../utilities/api/services';
import Home from '../pages/Home/Home';

export default function App() {
  const [client, setCLient] = useState(getUser());
  const [clientServices, setClientServices] = useState(null);
  const [isMobile, setIsMobile] = useState(false)

  const updateClient = (client) => {
    setCLient(client)
  }

  const getCurrentClientServices = async (client) => {
    const services = await getServices()
    if (!client) return
    const currentClientServices = services.filter(service => client.clientServices.includes(service.code))
    setClientServices(currentClientServices)
  }

  // check if device is mobile
  useEffect(() => {
    if(window.innerWidth <= 768){
      setIsMobile(true)
    }
    window.addEventListener('resize', () => {
      if(window.innerWidth <= 768){
        setIsMobile(true)
      } else {
        setIsMobile(false)
      }
    })
  }, [])

  return (
    <main className="App">
      {
        !client ?
        <main className='body login'>
          <Routes>
            <Route path="/*" element={<Login updateClient={updateClient} client={client} />} />
          </Routes>
        </main>
        :
        <main className='body'>
          <div className='navbar'>
            <NavBar client={client} updateClient={updateClient} />
          </div>
          <div className='pages'>
            <Routes>
              <Route path="*" element={<Home user={client} getCurrentClientServices={getCurrentClientServices} clientServices={clientServices} isMobile={isMobile} />} />
            </Routes>
          </div>
        </main>
      }
    </main>
  );
}
